import { render, staticRenderFns } from "./trigger-arguments.vue?vue&type=template&id=a87ab108"
import script from "./trigger-arguments.vue?vue&type=script&lang=js"
export * from "./trigger-arguments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports